module.exports = __webpack_public_path__ + "img/hy2.0fd81f10.jpg";